import * as React from "react";
import {cs} from "../../../../../../../react/chain-services";
import "./step-1-select-building.scss";
import {UseState} from "../../../../../../../react/use-state";
import {Header} from "../../common/header/header";
import {cx} from "emotion";
import {Select} from "../../../../../common/design2/select/select";

export const Step1SelectBuilding = ({buildingSelector, next}) => cs(
    ["form", (_, next) => buildingSelector.renderForm({next})],
    ({form}) => next({
        render: ({onCancel, cancelLabel, onNext}) => cs(
            ({}) => (
                <div className="step-1-select-building-8o1">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-condo.png"),
                        title: "Create Co-op/Condo Address List",
                        subTitle: "Build a list comprised of multi-family buildings and units on a particular street.",
                    })}

                    <div className="content">

                        <div className="form-group">
                            <div className="control-label">
                                Find Buildings on Street
                            </div>
                            {Select({
                                list: form.streets,
                                isSelected: form.isStreetSelected,
                                onChange: form.onSelectStreet,
                                itemToLabel: form.getStreetName,
                                placeholder: !form.streets ? "Loading..." : "Please select...",
                                xdQaName: "Find Building on Street"
                            })}
                        </div>

                        <div className="form-group">
                            {form.hasStreet() && <>
                                <div className="control-label">
                                    Retrieve Addresses in Building
                                </div>
                                {Select({
                                    list: form.buildings,
                                    isSelected: form.isBuildingSelected,
                                    onChange: form.onSelectBuilding,
                                    itemToLabel: form.getBuildingName,
                                    placeholder: form.buildingsError ? (
                                        "Error!"
                                    ) : !form.buildings ? (
                                        "Loading..."
                                    ) : (
                                        "Please select..."
                                    ),
                                    xdQaName: "Retrieve Addresses in Building"
                                })}

                                {form.buildingsError && (
                                    <div className="error">
                                        ERROR: {form.buildingsError}
                                    </div>
                                )}
                            </>}
                        </div>

                    </div>

                    <div className="footer">
                        <div className="text">
                            For assistance with condo list option please send an email to{" "}
                            <a
                                href={"mailto:maillist@elliman.com"}
                                xd-qa-type="link" 
                                xd-qa-name="mail to" >
                                maillist@elliman.com
                            </a>
                        </div>

                        <div className="buttons">
                            <button {...{
                                className: "cancel",
                                onClick: onCancel,
                                "xd-qa-type": "button",
                                "xd-qa-name": "Coop Condo List " + cancelLabel,
                            }}>
                                {cancelLabel}
                            </button>

                            {cs(
                                ["submitting", (_, next) => UseState({next})],
                                ({submitting}) => (
                                    <button {...{
                                        className: cx("next", {
                                            // disabled: !form.ready,
                                        }),
                                        disabled: !form.ready || submitting.value,
                                        onClick: async () => {
                                            if (!form.ready) {
                                                // if (!showErrors.value) {
                                                //     showErrors.onChange(true);
                                                // }
                                                // selectListSection.highlightErrors();
                                            } else {
                                                submitting.onChange(true);

                                                try {
                                                    await onNext(form.getValue());
                                                    form.clear();
                                                } finally {
                                                    submitting.onChange(false);
                                                }
                                            }
                                        },
                                        "xd-qa-type": "button",
                                        "xd-qa-name": "Coop Condo List Next",
                                    }}>
                                        Next
                                    </button>
                                ),
                            )}
                        </div>
                    </div>
                </div>
            ),
        )
    }),
);
